import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageUrlPipe } from '../../images/image-url.pipe';
import { StatusListItemComponent } from './status-list-item.component';
import { TranslocoModule } from '@jsverse/transloco';



@NgModule({
  declarations: [StatusListItemComponent],
  exports: [StatusListItemComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    ImageUrlPipe,
  ]
})
export class StatusListItemModule { }
